import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import moment from 'moment';
import React from 'react';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        date: {
            fontSize: theme.typography.h6.fontSize,
            lineHeight: 1,
        },
        nbPlaces: {
            fontSize: theme.typography.body2.fontSize,
            lineHeight: 1,
        },
        root: function (props) { return ({
            '&:hover': {
                backgroundColor: props.selected ? theme.palette.primary.main : fade(theme.palette.primary.light, 0.1),
            },
            alignItems: 'center',
            backgroundColor: props.selected ? theme.palette.primary.main : theme.palette.common.white,
            borderColor: props.selected ? theme.palette.primary.main : theme.palette.grey[300],
            borderStyle: 'solid',
            borderWidth: 1,
            color: props.selected ? theme.palette.common.white : theme.palette.grey[800],
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            height: 60,
            justifyContent: 'center',
            width: 85,
        }); },
    });
});
export default (function (_a) {
    var id = _a.id, date = _a.date, nbPlaces = _a.nbPlaces, selected = _a.selected, onSelect = _a.onSelect;
    var styles = useStyle({ selected: selected });
    var handleSelect = function () {
        if (onSelect) {
            onSelect(id);
        }
    };
    var showPlaces = function (nb) { return nb + " " + (nb === 1 ? "place" : 'places'); };
    return (React.createElement(Box, { className: styles.root, onClick: handleSelect },
        React.createElement(Typography, { className: styles.date }, moment(date).format('HH:mm')),
        React.createElement(Typography, { className: styles.nbPlaces }, showPlaces(nbPlaces))));
});
//# sourceMappingURL=index.js.map